import React from 'react';

import OrgSurveyCta from '@ivy/components/molecules/OrgSurveyCta';
import NavTemplate from '@ivy/components/templates/NavTemplate';
import useWhitelabel from '@ivy/lib/whitelabel/useWhitelabel';

import AcepHero from './AcepHero';
import AcepResources from './AcepResources';
import AcepValueProps from './AcepValueProps';

const AcepLanding = () => {
	const wl = useWhitelabel();
	return (
		<NavTemplate
			fullscreen
			showFooter
			showSupportLauncher
			pathIsCanonical
			TopBarProps={{
				transparentUntilScroll: true,
				sx: {
					borderStyle: 'none',
				},
			}}
			pageTitle={wl.productName}
			disableTitleSuffix
			pageDescription={wl.productDescription}
		>
			<AcepHero />
			<AcepValueProps />
			<AcepResources />
			<OrgSurveyCta />
		</NavTemplate>
	);
};

export default AcepLanding;
